<template>
  <v-container id="ur-list">
    <sala-municipio-header :payload="payload"> </sala-municipio-header>

    <v-row>
      <v-col
        ><h3><b>Mapa de Indicadores</b></h3></v-col
      >
      <v-col class="text-right">
        <v-btn outlined color="primary" class="ml-3" @click="gerarXlsx()">
          Gerar Excel
        </v-btn>
        <app-modal-insert-ur
          v-if="isAdmin"
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadIndicadoresMunicipio"
        >
          <template v-slot:title :edit="false">
            Cadastrar Indicadores
          </template>
        </app-modal-insert-ur>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <span>
              {{ item.nomeIndicador }}
            </span>
          </template>
          <template v-slot:item.nomeNivel="{ item }">
            <span v-html="item.nomeNivel"> </span>
          </template>
          <template v-slot:item.Serie="{ item }">
            <span v-html="item.Serie"> </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-insert-ur
                  v-if="isAdmin"
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @on-save="loadIndicadoresMunicipio"
                >
                  <template v-slot:title> Editar Indicadores </template>
                </app-modal-insert-ur>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-delete
                  v-if="isAdmin"
                  :object="item"
                  @on-save="loadIndicadoresMunicipio"
                >
                  <template v-slot:title> Deletar </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhum Indicador retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertUr from "./ModalInsert";
import { SalaIndicadoresMunicipioAPI } from "../API/SalaIndicadoresMunicipioAPI";
import { mapActions, mapGetters } from "vuex";
import GerarPdf from "../utils/geraXls";
import AppModalDelete from "./../components/ModalDelete";
import SalaMunicipioHeader from "../../sala-principal/components/SalaMunicipioHeader";

export default {
  components: {
    AppModalInsertUr,
    AppModalDelete,
    SalaMunicipioHeader,
  },
  data() {
    return {
      headers: [
        { text: "Indicador", value: "nome", width: "250px" },
        { text: "Nivel", value: "nomeNivel", width: "60px" },
        { text: "Objeto", value: "objeto", width: "250px" },
        { text: "Apuração", value: "nomeApuracao", width: "80px" },
        { text: "Responsavel", value: "responsavel", width: "150px" },
        { text: "Fonte", value: "nomeFonte", width: "80px" },
        { text: "Leitura", value: "nomeLeitura", width: "150px" },
        { text: "Unidade", value: "nomeUnidade", width: "150px" },
        { text: "Serie", value: "serie", width: "250px" },
        { text: "Metas", value: "metas", width: "250px" },
        { text: "Valor das metas", value: "valorApurado", width: "250px" },
        { text: "Previsto", value: "previsto", width: "250px" },
        { text: "Realizado", value: "realizado", width: "250px" },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
      ],
      payload: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadIndicadoresMunicipio() {
      this.setLoading(true);
      SalaIndicadoresMunicipioAPI.list()
        .then((resp) => {
          this.payload = resp.data.filter((i) => {
            return i.municipioId === this.cityId;
          });
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter os dados");
        });
    },
    gerarXlsx() {
      GerarPdf(this.payload, "Mapa de Indicadores");
    },
    GerarExcel() {
      this.setLoading(true);
      SalaIndicadoresMunicipioAPI.GerarExcel(this.$route.params.id)
        .then((resp) => {
          this.setLoading(false);
          const link = document.createElement("a");
          link.href =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" +
            resp.data;
          link.target = "_blank";
          link.download = "a.xlsx";
          link.click();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao gerar eXcel");
        });
    },
  },
  mounted() {
    this.loadIndicadoresMunicipio();
  },
  computed: {
    ...mapGetters(["isAdmin", "cityId"]),
  },
};
</script>
